/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import UsageByPeriodListPage from './usageByPeriodList/UsageByPeriodListPage'

type Props = {
  invoiceId?: number
}

const UsageByPeriod: React.FC<Props> = ({invoiceId}) => {
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Consumo por Período</h3>
        </div>
      </div>

      <div className='card-body border-top '>
        <UsageByPeriodListPage invoiceId={invoiceId} />
      </div>
    </div>
  )
}

export {UsageByPeriod}
